import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import store from '@/store/modules/store';
import locale from '@/store/modules/locale';
import order from '@/store/modules/order';
import main from '@/store/modules/main';
import layout from '@/store/modules/layout';
import constant from '@/store/modules/constant';
import chat from '@/store/modules/chat';
import board from '@/store/modules/board';
import user from '@/store/modules/user';
import search from '@/store/modules/search';
import recent from '@/store/modules/recent';
import googleAutoCompletion from '@/store/modules/googleAutoCompletion';
import point from '@/store/modules/myPage/point';
import coupon from '@/store/modules/myPage/coupon';
import my_review from '@/store/modules/myPage/review';
import cs from '@/store/modules/myPage/cs';
import cart from '@/store/modules/cart';
import product from '@/store/modules/product';
import favorite from '@/store/modules/favorite';
import bizmoney from '@/store/modules/bizmoney';
import payment from '@/store/modules/payment';
import address from '@/store/modules/myPage/address';
import bizNotification from '@/store/modules/bizNotification';
import banner from '@/store/modules/banner';
import review from '@/store/modules/review';
import dynamiclink from '@/store/modules/dynamiclink';

import admin_store from '@/store/modules/admin/store';
import admin_area from '@/store/modules/admin/area';
import admin_product from '@/store/modules/admin/product';
import admin_review from '@/store/modules/admin/review';
import admin_order from '@/store/modules/admin/order';
import admin_coupon from '@/store/modules/admin/coupon';
import admin_customer from '@/store/modules/admin/customer';

import sse from '@/store/modules/chat/sse';

import { createLogger } from 'vuex/dist/vuex.esm-browser.prod';
const embeddedLogger = createLogger({
  filter(mutation, stateBefore, stateAfter) {
    // if (mutation.type.includes('user/setUserPosition')) {
    // console.debug(
    //   'BEFORE :',
    //   mutation.type
    //   // stateBefore[mutation.type.substr(0, mutation.type.lastIndexOf('/'))][
    //   //   'position'
    //   // ]
    // );
    // console.debug(
    //   'AFTER :',
    //   mutation.type
    //   // stateAfter[mutation.type.substr(0, mutation.type.lastIndexOf('/'))][
    //   //   'position'
    //   // ]
    // );
    // }
  },
  logger: console
});

export default createStore({
  modules: {
    sse,
    address,
    board,
    layout,
    user,
    chat,
    locale,
    constant,
    recent,
    store,
    googleAutoCompletion,
    order,
    main,
    search,
    point,
    coupon,
    my_review,
    cs,
    cart,
    product,
    payment,
    bizmoney,
    favorite,
    bizNotification,
    banner,
    review,
    dynamiclink,

    admin_store,
    admin_area,
    admin_product,
    admin_review,
    admin_order,
    admin_coupon,
    admin_customer
  },
  plugins: [
    createPersistedState({
      key: 'union',
      paths: [
        'user',
        'locale',
        'constant',
        'chat.selectedRoom',
        'chat.header',
        'cart',
        'payment',
        'recent.storeList',
        'recent.productList',
        'store.storeCategoryNo',
        'main.tagList',
        'main.categoryList',
        'main.isExist',
        'main.cacheMeta',
        'banner.banners',
        'banner.cacheMeta'
      ]
    })
    // embeddedLogger
  ]
});
